import * as React from "react";
function SvgTriangleRight(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M8 0l16 16L8 32z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTriangleRight);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
